import { Configuration, PopupRequest } from "@azure/msal-browser";

/**
 * Configuration object to be passed to MSAL instance on creation. 
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md 
 */

// Environment variables for Entra ID configuration
// These should be set in .env.local file
const clientId = process.env.REACT_APP_AZURE_CLIENT_ID || '';
const tenantId = process.env.REACT_APP_AZURE_TENANT_ID || '';
const apiClientId = process.env.REACT_APP_API_CLIENT_ID || clientId;

// Allowed group Object ID - users must be in this group to access the app
export const ALLOWED_GROUP_ID = process.env.REACT_APP_ALLOWED_GROUP_ID || '';

export const msalConfig: Configuration = {
    auth: {
        clientId: clientId, // Application (client) ID from App Registration
        authority: `https://login.microsoftonline.com/${tenantId}`, // Your tenant ID
        redirectUri: '/', // Use relative path - MSAL will resolve to full URL
        postLogoutRedirectUri: '/',
    },
    cache: {
        cacheLocation: "sessionStorage", // Use sessionStorage for better redirect flow handling
    },
    system: {
        allowRedirectInIframe: false,
        loggerOptions: {
            logLevel: 3, // Error
        }
    }
};

/**
 * Scopes for initial login - only request basic user scopes that don't require admin consent
 * The API scope will be requested separately when calling the API
 */
export const loginRequest: PopupRequest = {
    scopes: ["openid", "profile", "email"]
};

/**
 * Add here the scopes to request when obtaining an access token for the API
 * This is requested separately from login to allow incremental consent
 */
export const apiRequest = {
    scopes: [`api://${apiClientId}/user_impersonation`]
};

/**
 * Validates that all required environment variables are set
 */
export const validateConfig = (): { isValid: boolean; errors: string[] } => {
    const errors: string[] = [];
    
    if (!clientId) {
        errors.push('REACT_APP_AZURE_CLIENT_ID is not set');
    }
    
    if (!tenantId) {
        errors.push('REACT_APP_AZURE_TENANT_ID is not set');
    }
    
    return {
        isValid: errors.length === 0,
        errors
    };
};
